/**
 * Událost změny sloupce.
 */
export type ColumnChangeEvent = {
    name: string,
    width: number,
}

/**
 * Posluchač změny sloupce.
 */
export type ColumnChangeListener = (event: ColumnChangeEvent) => void;

/**
 * Synchronizace mezi sloupci oddělené hlavičky a těla tabulky.
 */
export default class ColumnSynchronizer {

    widths: { [string]: number } = {};
    listeners: ColumnChangeListener[] = [];

    addListener(listener: ColumnChangeListener): void {
        this.listeners.push(listener);
    }

    removeListener(listener: ColumnChangeListener): void {
        this.listeners = this.listeners.filter(l => l !== listener);
    }

    getWidth(name: string): number {
        return this.widths[name];
    }

    setWidth(name: string, width: number): void {
        if (this.widths[name] !== width) {
            this.widths[name] = width;

            requestAnimationFrame(() => {
                const event = {name, width};
                for (const listener of this.listeners) {
                    listener(event);
                }
            });
        }
    }

}
